import pick from 'lodash/pick';
import isEqual from 'lodash/isEqual';

import { isqProps } from '../dashboard/autoinvest/data';

export const cleanUpIsqSubmission = (props, { timeHorizon }) => {
  const isqSubmission = pick(props, isqProps);

  // Perform employer type specific clean up to state.
  switch (isqSubmission.employmentType) {
    case 'employed':
      delete isqSubmission.employmentIndustry;
      delete isqSubmission.sourceOfIncome;
      delete isqSubmission.sameWorkAddress;
      break;

    case 'self_employed':
      delete isqSubmission.sourceOfIncome;
      if (isqSubmission.sameWorkAddress) {
        delete isqSubmission.employerAddress;
      }
      break;

    case 'retired':
      delete isqSubmission.sameWorkAddress;
      delete isqSubmission.employerAddress;
      break;

    case 'student':
      delete isqSubmission.employmentPositionHeld;
      delete isqSubmission.employmentIndustry;
      delete isqSubmission.sameWorkAddress;
      delete isqSubmission.employerAddress;
      break;

    case 'not_employed':
      delete isqSubmission.employer;
      delete isqSubmission.employmentPositionHeld;
      delete isqSubmission.employmentIndustry;
      delete isqSubmission.sameWorkAddress;
      delete isqSubmission.employerAddress;
      break;

    default:
      break;
  }

  // Clean up the follow up questions.
  if (isqSubmission.primaryInvestmentReason !== 'preserve') {
    delete isqSubmission.primaryInvestmentReasonFollowUp;
  }
  const experienceFollowUp =
    isqSubmission.expStocks === 'none'
    && isqSubmission.expBonds === 'none'
    && isqSubmission.expRealEstate === 'none'
    && isqSubmission.expPrivateEquity === 'none'
    && isqSubmission.expVentureCapital === 'none'
    && isqSubmission.expSmallBiz === 'none';
  if (!experienceFollowUp) {
    delete isqSubmission.experienceFollowUp;
  }
  if (Number.parseInt(isqSubmission.exit, 10) >= timeHorizon) {
    delete isqSubmission.exitFollowUp;
  }
  if (!isEqual(isqSubmission.risk, ['low'])) {
    delete isqSubmission.riskFollowUp;
  }

  // Cast to integers for submission.
  isqSubmission.annualIncome = Number.parseInt(isqSubmission.annualIncome, 10);
  isqSubmission.netWorth = Number.parseInt(isqSubmission.netWorth, 10);
  isqSubmission.netWorthSpecific = (isqSubmission.netWorthSpecific !== undefined
    && Number.parseInt(isqSubmission.netWorthSpecific, 10)) || undefined;

  // Clean up employerAddress.
  if (isqSubmission.employerAddress) {
    isqSubmission.employerAddress = pick(isqSubmission.employerAddress, [
      'country',
      'thoroughfare',
      'premise',
      'locality',
      'administrative_area',
      'postal_code',
    ]);
  }
  return isqSubmission;
};

export default {
  cleanUpIsqSubmission,
};
